import {
  DIET_TEMPLATE_LIST_REQUEST, DIET_TEMPLATE_LIST_SUCCESS, DIET_TEMPLATE_LIST_FAIL,
  DIET_TEMPLATE_CREATE_SUCCESS, DIET_TEMPLATE_UPDATE_SUCCESS, DIET_TEMPLATE_DELETE_SUCCESS,
  DIET_TEMPLATE_DETAILS_REQUEST, DIET_TEMPLATE_DETAILS_SUCCESS, DIET_TEMPLATE_DETAILS_FAIL,
  DIET_TEMPLATE_RESET, DIET_TEMPLATE_DETAILS_RESET
} from '../actions/types';

const initialState = {
  templates: [],
  templateDetails: null,
  loading: false,
  loadingDetails: false,
  success: false,
  error: null
};

export const dietTemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    case DIET_TEMPLATE_LIST_REQUEST:
      return { ...state, loading: true };
    case DIET_TEMPLATE_LIST_SUCCESS:
      return { ...state, loading: false, templates: action.payload };
    case DIET_TEMPLATE_LIST_FAIL:
      return { ...state, loading: false, error: action.payload };

    case DIET_TEMPLATE_CREATE_SUCCESS:
    case DIET_TEMPLATE_UPDATE_SUCCESS:
      return { ...state, success: true };

    case DIET_TEMPLATE_DELETE_SUCCESS:
      return { 
        ...state, 
        templates: state.templates.filter(t => t.id !== action.payload) 
      };

    case DIET_TEMPLATE_DETAILS_REQUEST:
      return { ...state, loadingDetails: true, templateDetails: null };
    case DIET_TEMPLATE_DETAILS_SUCCESS:
      return { ...state, loadingDetails: false, templateDetails: action.payload };
    case DIET_TEMPLATE_DETAILS_FAIL:
      return { ...state, loadingDetails: false, error: action.payload };

    case DIET_TEMPLATE_RESET:
      return { ...state, success: false, error: null };
    case DIET_TEMPLATE_DETAILS_RESET:
      return { ...state, templateDetails: null };

    default:
      return state;
  }
};